import {atom, useAtomValue} from 'jotai';

export type Services = 'dev-landing' | 'catalog' | 'kiosk' | 'landing';

export const currentServiceAtom = atom<Services>();

export const useCurrentService = () =>
  useAtomValue(currentServiceAtom) as Services; // гидрирует с сервера
